import DocumentFolder from './DocumentFolder';

export default DocumentFolder;
